import { MINIMUM_OLDER_MESSAGE_GROUPS_TO_VIRTUALIZE } from './constants';

type Args = {
	olderMessageGroupsCount: number;
	/**
	 * When true (e.g. an open via deep-link), virtualization is bypassed so the
	 * existing querySelector-based scroll path can find the target. The caller
	 * should mount all older groups eagerly in that case.
	 */
	isDeepLinkPending: boolean;
};

type Result = {
	isVirtualizationEnabled: boolean;
};

/**
 * Decides whether chat history should switch to the virtualized renderer.
 */
export const getVirtualizationState = ({
	olderMessageGroupsCount,
	isDeepLinkPending,
}: Args): Result => {
	if (isDeepLinkPending || olderMessageGroupsCount === 0) {
		return { isVirtualizationEnabled: false };
	}

	return {
		isVirtualizationEnabled: olderMessageGroupsCount >= MINIMUM_OLDER_MESSAGE_GROUPS_TO_VIRTUALIZE,
	};
};
